export interface IGameObject extends IProcessedImage {
  x: number;
  y: number;
  dy: number;
}

export interface IPickUpObject extends IGameObject {
  points: number;
  label: string;
  offsetTop: number;
  offsetBottom: number;
}

export interface IPlayerObject extends IGameObject {
  isInvulnerable?: boolean;
  isRespawning?: boolean;
  isDeathAnimating?: boolean;
  isJumping?: boolean;
  isOnGround?: boolean;
}

export interface IBackgroundObject extends IGameObject {
  placement: RushRunnerVerticalPlacement;
  speed: RushRunnerGameSpeed;
  offset: number;
}

export interface IObstacleObject extends IGameObject {
  flipVertically: boolean;
  placement: RushRunnerVerticalPlacement;
  offset: number;
}

export interface IProcessedImage {
  image?: HTMLImageElement;
  width: number;
  height: number;
}

export interface ImageConfig {
  maxWidth?: number; // maxWidth is optional
}

export type NormalizedImagesMap = { [url: string]: HTMLImageElement };
export type JumpKey = 'Space' | 'ArrowUp' | 'KeyW';

export enum RushRunnerVerticalPlacement {
  TOP,
  MIDDLE,
  BOTTOM,
  RANDOM
}

export enum Lane {
  TOP,
  MIDDLE,
  BOTTOM
}

export enum RushRunnerGameSpeed {
  SLOW,
  NORMAL,
  FAST
}

export enum RushRunnerAnimation {
  NO_ANIMATION,
  PULSE
}
